import React from 'react';
import ReactDOM from 'react-dom/client';
import './firebase';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PublicHome from './PublicHome';
import Contact from './Contact';
import About from './About';
import PropertyPublic from './PropertyPublic';
import Enquiry from './Enquiry';
import CustomerSignIn from './CustomerSignIn';
import CustomerSignUp from './CustomerSignUp';
import CustomerProfile from './CustomerProfile';
import Dashboard from './Dashboard';
import Properties from './Properties';
import PropertyNew from './PropertyNew';
import Tenants from './Tenants';
import TenantNew from './TenantNew';
import Maintenance from './Maintenance';
import MaintenanceNew from './MaintenanceNew';
import TenantMaintenanceRequests from './TenantMaintenanceRequests';
import Analytics from './Analytics';
import Staff from './Staff';
import StaffNew from './StaffNew';
import Enquiries from './Enquiries';
import Accounts from './Accounts';
import RentManagement from './RentManagement';
import Feedback from './Feedback';
import TenantPortalLayout from './TenantPortalLayout';
import TenantDashboard from './TenantDashboard';
import TenantMaintenance from './TenantMaintenance';
import TenantRent from './TenantRent';
import TenantFeedback from './TenantFeedback';
import StaffDashboard from './StaffDashboard';
import Profile from './Profile';
import ScrollToTop from './ScrollToTop';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/sign-in" element={<CustomerSignIn />} />
        <Route path="/sign-up" element={<CustomerSignUp />} />
        <Route path="/account" element={<CustomerProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="/property/:id/enquiry" element={<Enquiry />} />
        <Route path="/property/:id" element={<PropertyPublic />} />
        <Route path="/admin" element={<App />} />
        <Route path="/tenant" element={<TenantPortalLayout />}>
          <Route index element={<TenantDashboard />} />
          <Route path="maintenance" element={<TenantMaintenance />} />
          <Route path="rent" element={<TenantRent />} />
          <Route path="feedback" element={<TenantFeedback />} />
        </Route>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/new" element={<PropertyNew />} />
        <Route path="/properties/:id/edit" element={<PropertyNew />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/new" element={<TenantNew />} />
        <Route path="/tenants/:id/edit" element={<TenantNew />} />
        <Route path="/enquiries" element={<Enquiries />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/rent-management" element={<RentManagement />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/maintenance-requests" element={<TenantMaintenanceRequests />} />
        <Route path="/maintenance/new" element={<MaintenanceNew />} />
        <Route path="/maintenance/:id/edit" element={<MaintenanceNew />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/staff/new" element={<StaffNew />} />
        <Route path="/staff/:id/edit" element={<StaffNew />} />
        <Route path="/staff-dashboard" element={<StaffDashboard />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
